import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "form-control me-2" }
const _hoisted_3 = { class: "form-control mx-1" }
const _hoisted_4 = { class: "form-control ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control me-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.giorno) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.composeAndEmit && _ctx.composeAndEmit(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giorniList, (item, i) => {
              return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.giorno]
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "form-control mx-1",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mese) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.composeAndEmit && _ctx.composeAndEmit(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mesiList, (item, i) => {
              return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.mese]
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "form-control ms-2",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.anno) = $event)),
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.composeAndEmit && _ctx.composeAndEmit(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anniList, (item, i) => {
              return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.anno]
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.giorno), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.mese), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.anno), 1)
        ], 64))
  ]))
}